




// import React from 'react';
// import '../styles/copilotDelivery.css';

// const CopilotDelivery = () => {
//     const deliverySteps = [
//         {
//             number: "01",
//             title: "Readiness Before Rollout",
//             intro: "Audit before action.",
//             details: "We assess licensing, data exposure, and identity maturity to provide an actionable roadmap. You receive a clear path forward, not assumptions."
//         },
//         {
//             number: "02",
//             title: "Security-First Architecture",
//             intro: "Enable AI with trust.",
//             details: "We implement Entra ID best practices and Conditional Access to ensure Copilot accelerates work without increasing risk."
//         },
//         {
//             number: "03",
//             title: "Data Governance & Compliance",
//             intro: "Clean data, safe AI.",
//             details: "Utilizing Microsoft Purview for sensitivity labeling and DLP enforcement to ensure intentional, compliant AI usage."
//         },
//         {
//             number: "04",
//             title: "Structured Deployment",
//             intro: "Enterprise-grade discipline.",
//             details: "From license provisioning to pilot programs, we ensure a predictable rollout with minimal disruption to your daily operations."
//         },
//         {
//             number: "05",
//             title: "Adoption & Outcomes",
//             intro: "People-centric transformation.",
//             details: "Role-based training and productivity playbooks ensure Copilot becomes a daily tool that drives measurable business value."
//         },
//         {
//             number: "06",
//             title: "Ongoing Optimization",
//             intro: "Continuous evolution.",
//             details: "Continuous support for feature updates and expansion into custom AI agents within Copilot Studio."
//         }
//     ];

//     return (
//         <section className="delivery-section">
//             <div className="delivery-header">
//                 <span className="pre-heading">The Roadmap</span>
//                 <h2 className="delivery-heading">How Synectiks Delivers Copilot Integration</h2>
//             </div>

//             <div className="timeline-container">
//                 <div className="central-line"></div>
                
//                 {deliverySteps.map((step, index) => (
//                     <div className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`} key={index}>
//                         <div className="timeline-dot">
//                             <div className="dot-inner"></div>
//                         </div>
                        
//                         <div className="step-card">
//                             <span className="step-num">{step.number}</span>
//                             <h3 className="step-title">{step.title}</h3>
//                             <p className="step-intro">{step.intro}</p>
//                             <p className="step-details">{step.details}</p>
//                         </div>
                        
//                         <div className="step-spacer"></div>
//                     </div>
//                 ))}
//             </div>
//         </section>
//     );
// };

// export default CopilotDelivery;















import React from 'react';
import '../styles/copilotDelivery.css';

const CopilotDelivery = () => {
    const deliverySteps = [
        { number: "01", title: "Readiness Before Rollout", intro: "Audit before action.", details: "We assess licensing, data exposure, and identity maturity to provide an actionable roadmap. You receive a clear path forward, not assumptions." },
        { number: "02", title: "Security-First Architecture", intro: "Enable AI with trust.", details: "We implement Entra ID best practices and Conditional Access to ensure Copilot accelerates work without increasing risk." },
        { number: "03", title: "Data Governance & Compliance", intro: "Clean data, safe AI.", details: "Utilizing Microsoft Purview for sensitivity labeling and DLP enforcement to ensure intentional, compliant AI usage." },
        { number: "04", title: "Structured Deployment", intro: "Enterprise-grade discipline.", details: "From license provisioning to pilot programs, we ensure a predictable rollout with minimal disruption to your daily operations." },
        { number: "05", title: "Adoption & Outcomes", intro: "People-centric transformation.", details: "Role-based training and productivity playbooks ensure Copilot becomes a daily high-value tool." },
        { number: "06", title: "Ongoing Optimization", intro: "Continuous evolution.", details: "Continuous support for feature updates and expansion into custom AI agents within Copilot Studio." }
    ];

    return (
        <section className="delivery-section">
            <div className="delivery-header">
                <span className="pre-heading">THE ROADMAP</span>
                <h2 className="delivery-heading">How Synectiks Delivers Copilot Integration</h2>
            </div>

            <div className="timeline-container">
                {/* Line is now hidden via CSS on mobile */}
                <div className="central-line"></div>
                {deliverySteps.map((step, index) => (
                    <div className={`timeline-item ${index % 2 === 0 ? 'left-item' : 'right-item'}`} key={index}>
                        {/* Dot is now hidden via CSS on mobile */}
                        <div className="timeline-dot">
                            <div className="dot-inner"></div>
                        </div>
                        <div className="step-card">
                            <span className="step-num">{step.number}</span>
                            <h3 className="step-title">{step.title}</h3>
                            <p className="step-intro">{step.intro}</p>
                            <p className="step-details">{step.details}</p>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default CopilotDelivery;